import { render, staticRenderFns } from "./UnitField.vue?vue&type=template&id=51f6a8bf&"
import script from "./UnitField.vue?vue&type=script&lang=js&"
export * from "./UnitField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/semaphore/fabric-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51f6a8bf')) {
      api.createRecord('51f6a8bf', component.options)
    } else {
      api.reload('51f6a8bf', component.options)
    }
    module.hot.accept("./UnitField.vue?vue&type=template&id=51f6a8bf&", function () {
      api.rerender('51f6a8bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/equipment/customComponents/UnitField.vue"
export default component.exports